import { asyncActionType } from '../utils/reduxActions';

export const FILTER_ACTIONS = {
    GET_APPLICATIONS_LIST: asyncActionType('[MUNICIPALITY]GET_APPLICATION_LIST'),
    GET_APPLICATIONS_LIST_BEGIN: '[MUNICIPALITY]GET_APPLICATION_LIST_BEGIN',

    GET_APPLICATIONS_DETAIL: asyncActionType('[MUNICIPALITY]GET_APPLICATIONS_DETAIL'),
    GET_APPLICATIONS_DETAIL_BEGIN: '[MUNICIPALITY]GET_APPLICATIONS_DETAIL',

    GET_FILE_LIST: asyncActionType('[MUNICIPALITY]GET_FILE_LIST'),
    GET_FILE_LIST_BEGIN: '[MUNICIPALITY]GET_FILE_LIST_BEGIN',

    DELETE_LICENSE_FILE_STATE: asyncActionType('[MUNICIPALITY]DELETE_LICENSE_FILE_STATE'),
    DELETE_LICENSE_FILE: '[MUNICIPALITY]DELETE_LICENSE_FILE',

    GET_LICENSE_ACCOUNTING: asyncActionType('[MUNICIPALITY]GET_LICENSE_ACCOUNTING'),
    GET_LICENSE_ACCOUNTING_BEGIN: '[MUNICIPALITY]GET_LICENSE_ACCOUNTING_BEGIN',

    GET_AUDIT_HISTORY: asyncActionType('[MUNICIPALITY]GET_AUDIT_HISTORY'),
    GET_AUDIT_HISTORY_BEGIN: '[MUNICIPALITY]GET_AUDIT_HISTORY_BEGIN',

    GET_LICENSEE_HISTORY: asyncActionType('[MUNICIPALITY]GET_LICENSEE_HISTORY'),
    GET_LICENSEE_HISTORY_BEGIN: '[MUNICIPALITY]GET_LICENSEE_HISTORY_BEGIN',

    GET_SITE: asyncActionType('[MUNICIPALITY]GET_SITE'),
    USER_AUTHENTICATED: '[MUNICIPALITY]USER_AUTHENTICATED',
    GET_AUTHENTICATION_TOKEN: '[MUNICIPALITY]GET_AUTHENTICATION_TOKEN',

    DOWNLOAD_FILE_DOCUMENT: asyncActionType('[MUNICIPALITY]DOWNLOAD_FILE_DOCUMENT'),
    DOWNLOAD_FILE_DOCUMENT_BEGIN: '[MUNICIPALITY]DOWNLOAD_FILE_DOCUMENT_BEGIN',

    LICENSE_SEARCH: asyncActionType('[MUNICIPALITY]LICENSE_SEARCH'),
    LICENSE_SEARCH_BEGIN: '[MUNICIPALITY]LICENSE_SEARCH_BEGIN',

    UPDATE_LICENSE: asyncActionType('[MUNICIPALITY]UPDATE_LICENSE'),
    UPDATE_LICENSE_BEGIN: '[MUNICIPALITY]UPDATE_LICENSE_BEGIN',

    CHANGE_LICENSE_FILTERS: '[MUNICIPALITY]CHANGE_LICENSE_FILTERS',
    APPLY_FILTERS: '[MUNICIPALITY]APPLY_FILTERS',

    EXPORT_LICENSES: '[MUNICIPALITY]EXPORT_LICENSES',

    GET_LICENSE_TYPES: asyncActionType('[MUNICIPALITY]GET_LICENSE_TYPES'),
    GET_LICENSE_TYPES_BEGIN: '[MUNICIPALITY]GET_LICENSE_TYPES_BEGIN',

    GET_VIOLATION_LIST: asyncActionType('[MUNICIPALITY]GET_VIOLATION_LIST'),
    GET_VIOLATION_LIST_BEGIN: '[MUNICIPALITY]GET_VIOLATION_LIST_BEGIN',

    GET_INSPECTION_LIST: asyncActionType('[MUNICIPALITY]GET_INSPECTION_LIST'),
    GET_INSPECTION_LIST_BEGIN: '[MUNICIPALITY]GET_INSPECTION_LIST_BEGIN',

    GET_APPOINTMENT_INSPECTION_LIST: asyncActionType('[MUNICIPALITY]GET_INSPECTION_LIST'),
    GET_APPOINTMENT_INSPECTION_LIST_BEGIN: '[MUNICIPALITY]GET_APPOINTMENT_INSPECTION_LIST_BEGIN',

    GET_CATEGORY_LIST: asyncActionType('[MUNICIPALITY]GET_CATEGORY_LIST'),
    GET_CATEGORY_LIST_BEGIN: '[MUNICIPALITY]GET_CATEGORY_LIST_BEGIN',

    GET_COMMENT_LIST: asyncActionType('[MUNICIPALITY]GET_COMMENT_LIST'),
    GET_COMMENT_LIST_BEGIN: '[MUNICIPALITY]GET_COMMENT_LIST_BEGIN',

    ADD_VIOLATION: asyncActionType('[MUNICIPALITY]ADD_VIOLATION'),
    ADD_VIOLATION_BEGIN: '[MUNICIPALITY]ADD_VIOLATION_BEGIN',

    ADD_INSPECTION: asyncActionType('[MUNICIPALITY]ADD_INSPECTION'),
    ADD_INSPECTION_BEGIN: '[MUNICIPALITY]ADD_INSPECTION_BEGIN',

    ADD_APPOINTMENT_INSPECTION: asyncActionType('[MUNICIPALITY]ADD_APPOINTMENT_INSPECTION'),
    ADD_APPOINTMENT_INSPECTION_BEGIN: '[MUNICIPALITY]ADD_APPOINTMENT_INSPECTION_BEGIN',

    DELETE_APPOINTMENT_INSPECTION: asyncActionType('[MUNICIPALITY]DELETE_APPOINTMENT_INSPECTION'),
    DELETE_APPOINTMENT_INSPECTION_BEGIN: '[MUNICIPALITY]DELETE_APPOINTMENT_INSPECTION_BEGIN',

    ADD_COMMENT: asyncActionType('[MUNICIPALITY]ADD_COMMENT'),
    ADD_COMMENT_BEGIN: '[MUNICIPALITY]ADD_COMMENT_BEGIN',

    GET_USER_LIST: asyncActionType('[MUNICIPALITY]GET_USER_LIST'),
    GET_USER_LIST_BEGIN: '[MUNICIPALITY]GET_USER_LIST_BEGIN',

    GET_INSPECTION_TYPE: asyncActionType('[MUNICIPALITY]GET_INSPECTION_TYPE'),
    GET_INSPECTION_TYPE_BEGIN: '[MUNICIPALITY]GET_INSPECTION_TYPE_BEGIN',

    DELETE_VIOLATION: asyncActionType('[MUNICIPALITY]DELETE_VIOLATION'),
    DELETE_VIOLATION_BEGIN: '[MUNICIPALITY]DELETE_VIOLATION_BEGIN',

    GET_PERSON_DETAIL: asyncActionType('[MUNICIPALITY]GET_PERSON_DETAIL'),
    GET_PERSON_DETAIL_BEGIN: '[MUNICIPALITY]GET_PERSON_DETAIL',

    UPDATE_PERSON: asyncActionType('[MUNICIPALITY]UPDATE_PERSON'),
    UPDATE_PERSON_BEGIN: '[MUNICIPALITY]UPDATE_PERSON_BEGIN',

    GET_PERSON_LICENSES: asyncActionType('[MUNICIPALITY]GET_PERSON_LICENSES'),
    GET_PERSON_LICENSES_BEGIN: '[MUNICIPALITY]GET_PERSON_LICENSES',

    DELETE_INSPECTION_RECORD: asyncActionType('[MUNICIPALITY]DELETE_INSPECTION_RECORD'),
    DELETE_INSPECTION_RECORD_BEGIN: '[MUNICIPALITY]DELETE_INSPECTION_RECORD_BEGIN',

    GET_INVOICE_TYPES: asyncActionType('[MUNICIPALITY]GET_INVOICE_TYPES'),
    GET_INVOICE_TYPES_BEGIN: '[MUNICIPALITY]GET_INVOICE_TYPES_BEGIN',

    GET_FEE_TYPES: asyncActionType('[MUNICIPALITY]GET_FEE_TYPES'),
    GET_FEE_TYPES_BEGIN: '[MUNICIPALITY]GET_FEE_TYPES_BEGIN',

    GET_JOURNAL_ENTRIES: asyncActionType('[MUNICIPALITY]GET_JOURNAL_ENTRIES'),
    GET_JOURNAL_ENTRIES_BEGIN: '[MUNICIPALITY]GET_JOURNAL_ENTRIES_BEGIN',

    ADD_JOURNAL_ENTRY: asyncActionType('[MUNICIPALITY]ADD_JOURNAL_ENTRY'),
    ADD_JOURNAL_ENTRY_BEGIN: '[MUNICIPALITY]ADD_JOURNAL_ENTRY_BEGIN',

    ADD_LINE_ITEMS: asyncActionType('[MUNICIPALITY]ADD_LINE_ITEMS'),
    ADD_LINE_ITEMS_BEGIN: '[MUNICIPALITY]ADD_LINE_ITEMS_BEGIN',

    VOID_INVOICE: asyncActionType('[MUNICIPALITY]VOID_INVOICE'),
    VOID_INVOICE_BEGIN: '[MUNICIPALITY]VOID_INVOICE_BEGIN',

    ADD_PERSON: asyncActionType('[APPLICATION]ADD_PERSON'),
    ADD_PERSON_BEGIN: '[APPLICATION]ADD_PERSON_BEGIN',

    SET_NOTIFICATION: '[MUNICIPALITY]SET_NOTIFICATION',

    GET_INSPECTION_DETAIL_BY_ID: asyncActionType('[APPLICATION]GET_INSPECTION_DETAIL_BY_ID'),
    GET_INSPECTION_DETAIL_BY_ID_BEGIN: '[APPLICATION]GET_INSPECTION_DETAIL_BY_ID_BEGIN',

    UPDATE_INSPECTION: asyncActionType('[APPLICATION]UPDATE_INSPECTION'),
    UPDATE_INSPECTION_BEGIN: '[APPLICATION]UPDATE_INSPECTION_BEGIN',

    SET_ACTIVE_TAB: '[APPLICATION]SET_ACTIVE_TAB',

    GET_INSPECTION_DETAIL: asyncActionType('[MUNICIPALITY]GET_INSPECTION_DETAIL'),
    GET_INSPECTION_DETAIL_BEGIN: '[MUNICIPALITY]GET_INSPECTION_DETAIL_BEGIN',
    GET_APPOINTMENT_LIST_BEGIN: '[APPLICATION]GET_APPOINTMENT_LIST_BEGIN',
    GET_APPOINTMENT_LIST: asyncActionType('[APPLICATION]GET_APPOINTMENT_LIST'),

    GET_APPOINTMENT_TYPE_LIST_BEGIN: '[APPLICATION]GET_APPOINTMENT_TYPE_LIST_BEGIN',
    GET_APPOINTMENT_TYPE_LIST: asyncActionType('[APPLICATION]GET_APPOINTMENT_TYPE_LIST'),

    GET_PERSON_CONTACTS: asyncActionType('[APPLICATION]GET_PERSON_CONTACTS'),
    GET_PERSON_CONTACTS_BEGIN: '[APPLICATION]GET_PERSON_CONTACTS_BEGIN',

    ADD_PERSON_CONTACT: asyncActionType('[APPLICATION]ADD_PERSON_CONTACT'),
    ADD_PERSON_CONTACT_BEGIN: '[APPLICATION]ADD_PERSON_CONTACT_BEGIN',

    UPDATE_PERSON_CONTACT: asyncActionType('[APPLICATION]UPDATE_PERSON_CONTACT'),
    UPDATE_PERSON_CONTACT_BEGIN: '[APPLICATION]UPDATE_PERSON_CONTACT_BEGIN',

    GET_CONTACT_TYPES: asyncActionType('[APPLICATION]GET_CONTACT_TYPES'),
    GET_CONTACT_TYPES_BEGIN: '[APPLICATION]GET_CONTACT_TYPES_BEGIN',

    GET_LICENSE_LIST_APPOINTMENT_BEGIN: '[APPLICATION]GET_LICENSE_LIST_APPOINTMENT_BEGIN',
    GET_LICENSE_LIST_APPOINTMENT: asyncActionType('[APPLICATION]GET_LICENSE_LIST_APPOINTMENT'),

    ADD_APPOINTMENT_BEGIN: '[APPLICATION]ADD_APPOINTMENT_BEGIN',
    ADD_APPOINTMENT: asyncActionType('[APPLICATION]ADD_APPOINTMENT'),

    GET_PERSON_ACCOUNTING: asyncActionType('[MUNICIPALITY]GET_PERSON_ACCOUNTING'),
    GET_PERSON_ACCOUNTING_BEGIN: '[MUNICIPALITY]GET_PERSON_ACCOUNTING_BEGIN',

    GET_VIOLATION_DETAIL_BY_ID: asyncActionType('[APPLICATION]GET_VIOLATION_DETAIL_BY_ID'),
    GET_VIOLATION_DETAIL_BY_ID_BEGIN: '[APPLICATION]GET_VIOLATION_DETAIL_BY_ID_BEGIN',

    UPDATE_VIOLATION: asyncActionType('[APPLICATION]UPDATE_VIOLATION'),
    UPDATE_VIOLATION_BEGIN: '[APPLICATION]UPDATE_VIOLATION_BEGIN',
    ADD_INSPECTION_COMMENT: asyncActionType('[APPLICATION]ADD_INSPECTION_COMMENT'),
    ADD_INSPECTION_COMMENT_BEGIN: '[APPLICATION]ADD_INSPECTION_COMMENT_BEGIN',

    INSPECTION_COMMENT_LIST: asyncActionType('[APPLICATION]INSPECTION_COMMENT_LIST'),
    INSPECTION_COMMENT_LIST_BEGIN: '[APPLICATION]INSPECTION_COMMENT_LIST_BEGIN',

    ADD_LICENSE: asyncActionType('[APPLICATION]ADD_LICENSE'),
    ADD_LICENSE_BEGIN: '[APPLICATION]ADD_LICENSE_BEGIN',
    GET_APPOINTMENT_DETAIL: asyncActionType('[APPLICTION]GET_APPOINTMENT_DETAIL'),
    GET_APPOINTMENT_DETAIL_BEGIN: '[APPLICATION]GET_APPOINTMENT_DETAIL_BEGIN',

    GET_APPOINTMENT_DETAIL_BY_ID: asyncActionType('[APPLICATION]GET_APPOINTMENT_DETAIL_BY_ID'),
    GET_APPOINTMENT_DETAIL_BY_ID_BEGIN: '[APPLICATION]GET_APPOINTMENT_DETAIL_BY_ID_BEGIN',

    UPDATE_APPOINTMENT: asyncActionType('[APPLICATION]UPDATE_APPOINTMENT'),
    UPDATE_APPOINTMENT_BEGIN: '[APPLICATION]UPDATE_APPOINTMENT_BEGIN',

    ADD_VIOLATION_COMMENT: asyncActionType('[APPLICATION]ADD_VIOLATION_COMMENT'),
    ADD_VIOLATION_COMMENT_BEGIN: '[APPLICATION]ADD_VIOLATION_COMMENT_BEGIN',

    VIOLATION_COMMENT_LIST: asyncActionType('[APPLICATION]VIOLATION_COMMENT_LIST'),
    VIOLATION_COMMENT_LIST_BEGIN: '[APPLICATION]VIOLATION_COMMENT_LIST_BEGIN',

    ADD_CITATION_COMMENT: asyncActionType('[APPLICATION]ADD_CITATION_COMMENT'),
    ADD_CITATION_COMMENT_BEGIN: '[APPLICATION]ADD_CITATION_COMMENT_BEGIN',

    CITATION_COMMENT_LIST: asyncActionType('[APPLICATION]CITATION_COMMENT_LIST'),
    CITATION_COMMENT_LIST_BEGIN: '[APPLICATION]CITATION_COMMENT_LIST_BEGIN',

    GET_CITATION_LIST: asyncActionType('[APPLICATION]GET_CITATION_LIST'),
    GET_CITATION_LIST_BEGIN: '[APPLICATION]GET_CITATION_LIST_BEGIN',
    SET_CITATION_LIST_COUNT: asyncActionType('[APPLICATION]SET_CITATION_LIST_COUNT'),

    GET_CITATION_DETAIL: asyncActionType('[APPLICATION]GET_CITATION_DETAIL'),
    GET_CITATION_DETAIL_BEGIN: '[APPLICATION]GET_CITATION_DETAIL_BEGIN',

    UPDATE_CITATION: asyncActionType('[APPLICATION]UPDATE_CITATION'),
    UPDATE_CITATION_BEGIN: '[APPLICATION]UPDATE_CITATION_BEGIN',

    GET_CITATIONS_AUTHENTICATION_TOKEN: '[MUNICIPALITY]GET_CITATIONS_AUTHENTICATION_TOKEN',

    GET_CITATIONS_FILE_LIST: asyncActionType('[APPLICATION]GET_CITATIONS_FILE_LIST'),
    GET_CITATIONS_FILE_LIST_BEGIN: '[APPLICATION]GET_CITATIONS_FILE_LIST_BEGIN',

    DELETE_CITATIONS_FILE_DOCUMENT: asyncActionType('[APPLICATION]DELETE_CITATIONS_FILE_DOCUMENT'),
    DELETE_CITATIONS_FILE_DOCUMENT_BEGIN: '[APPLICATION]DELETE_CITATIONS_FILE_DOCUMENT_BEGIN',

    DOWNLOAD_CITATIONS_FILE_DOCUMENT: asyncActionType('[APPLICATION]DOWNLOAD_CITATIONS_FILE_DOCUMENT'),
    DOWNLOAD_CITATIONS_FILE_DOCUMENT_BEGIN: '[APPLICATION]DOWNLOAD_CITATIONS_FILE_DOCUMENT_BEGIN',

    DELETE_APPOINTMENT_RECORD: asyncActionType('[APPLICATION]DELETE_APPOINTMENT_RECORD'),
    DELETE_APPOINTMENT_RECORD_BEGIN: '[APPLICATION]DELETE_APPOINTMENT_RECORD_BEGIN',

    DELETE_CONTACT_RECORD: asyncActionType('[APPLICATION]DELETE_CONTACT_RECORD'),
    DELETE_CONTACT_RECORD_BEGIN: '[APPLICATION]DELETE_CONTACT_RECORD_BEGIN',

    GET_PERSON_COMMENT_LIST: asyncActionType('[APPLICATION]GET_PERSON_COMMENT_LIST'),
    GET_PERSON_COMMENT_LIST_BEGIN: '[APPLICATION]GET_PERSON_COMMENT_LIST_BEGIN',

    ADD_PERSON_COMMENT: asyncActionType('[APPLICATION]ADD_PERSON_COMMENT'),
    ADD_PERSON_COMMENT_BEGIN: '[APPLICATION]ADD_PERSON_COMMENT_BEGIN',

    GET_SPECIFIC_LICENSES: asyncActionType('[APPLICATION]GET_SPECIFIC_LICENSES'),
    GET_SPECIFIC_LICENSES_BEGIN: '[APPLICATION]GET_SPECIFIC_LICENSES_BEGIN',

    GET_MERGE_TEMPLATES: asyncActionType('[APPLICATION]GET_MERGE_TEMPLATES'),
    GET_MERGE_TEMPLATES_BEGIN: '[APPLICATION]GET_MERGE_TEMPLATES_BEGIN',

    DOWNLOAD_DOCUMENT: asyncActionType('[APPLICATION]DOWNLOAD_DOCUMENT'),
    DOWNLOAD_DOCUMENT_BEGIN: '[APPLICATION]DOWNLOAD_DOCUMENT_BEGIN',

    ADD_APPOINTMENT_COMMENT: asyncActionType('[APPLICATION]ADD_APPOINTMENT_COMMENT'),
    ADD_APPOINTMENT_COMMENT_BEGIN: '[APPLICATION]ADD_APPOINTMENT_COMMENT_BEGIN',

    APPOINTMENT_COMMENT_LIST: asyncActionType('[APPLICATION]APPOINTMENT_COMMENT_LIST'),
    APPOINTMENT_COMMENT_LIST_BEGIN: '[APPLICATION]APPOINTMENT_COMMENT_LIST_BEGIN',

    GET_PERSON_TYPES: asyncActionType('[APPLICATION]GET_PERSON_TYPES'),
    GET_PERSON_TYPES_BEGIN: '[APPLICATION]GET_PERSON_TYPES_BEGIN',

    GET_PERSON_TYPE_FORM: asyncActionType('[APPLICATION]GET_PERSON_TYPE_FORM'),
    GET_PERSON_TYPE_FORM_BEGIN: '[APPLICATION]GET_PERSON_TYPE_FORM_BEGIN',

    GET_EVENT_LIST: asyncActionType('[APPLICATION]GET_EVENT_LIST'),
    GET_EVENT_LIST_BEGIN: '[APPLICATION]GET_EVENT_LIST_BEGIN',

    SET_EVENT_LIST_COUNT: asyncActionType('[APPLICATION]SET_EVENT_LIST_COUNT'),

    CHANGE_EVENT_FILTERS: '[APPLICATION]CHANGE_EVENT_FILTERS',

    APPLY_EVENT_FILTERS: '[APPLICATION]APPLY_EVENT_FILTERS',

    CHANGE_CITATION_FILTERS: '[APPLICATION]CHANGE_CITATION_FILTERS',

    APPLY_CITATION_FILTERS: '[APPLICATION]APPLY_CITATION_FILTERS',

    GET_INSPECTION_VIOLATION_LIST: asyncActionType('[APPLICATION]GET_INSPECTION_VIOLATION_LIST'),
    GET_INSPECTION_VIOLATION_LIST_BEGIN: '[APPLICATION]GET_INSPECTION_VIOLATION_LIST_BEGIN',

    DELETE_INSPECTION_VIOLATION: asyncActionType('[APPLICATION]DELETE_INSPECTION_VIOLATION'),
    DELETE_INSPECTION_VIOLATION_BEGIN: '[APPLICATION]DELETE_INSPECTION_VIOLATION_BEGIN',

    ADD_INSPECTION_VIOLATION: asyncActionType('[APPLICATION]ADD_INSPECTION_VIOLATION'),
    ADD_INSPECTION_VIOLATION_BEGIN: '[APPLICATION]ADD_INSPECTION_VIOLATION_BEGIN',

    TIME_SHEET_LIST: asyncActionType('[APPLICATION]TIME_SHEET_LIST'),
    TIME_SHEET_LIST_BEGIN: '[APPLICATION]TIME_SHEET_LIST_BEGIN',

    SET_TIME_SHEET_LIST_COUNT: asyncActionType('[APPLICATION]SET_TIME_SHEET_LIST_COUNT'),

    PERSON_SEARCH: asyncActionType('[APPLICATION]PERSON_SEARCH'),

    GET_TIME_SHEET_TYPES: asyncActionType('[APPLICATION]GET_TIME_SHEET_TYPES'),
    GET_TIME_SHEET_TYPES_BEGIN: '[APPLICATION]GET_TIME_SHEET_TYPES_BEGIN',

    GET_TIME_SHEET_CATEGORIES: asyncActionType('[APPLICATION]GET_TIME_SHEET_CATEGORIES'),
    GET_TIME_SHEET_CATEGORIES_BEGIN: '[APPLICATION]GET_TIME_SHEET_CATEGORIES_BEGIN',

    GET_TIME_SHEET_EXPENSE_CATEGORIES: asyncActionType('[APPLICATION]GET_TIME_SHEET_EXPENSE_CATEGORIES'),
    GET_TIME_SHEET_EXPENSE_CATEGORIES_BEGIN: '[APPLICATION]GET_TIME_SHEET_EXPENSE_CATEGORIES_BEGIN',

    OPEN_TIME_SHEET_FOR_SELECTED_DATE: asyncActionType('[APPLICATION]OPEN_TIME_SHEET_FOR_SELECTED_DATE'),
    OPEN_TIME_SHEET_FOR_SELECTED_DATE_BEGIN: '[APPLICATION]OPEN_TIME_SHEET_FOR_SELECTED_DATE_BEGIN',

    GET_INBOX_LIST: asyncActionType('[APPLICATION]GET_INBOX_LIST'),
    GET_INBOX_LIST_BEGIN: '[APPLICATION]GET_INBOX_LIST_BEGIN',
    SET_INBOX_LIST_COUNT: asyncActionType('[APPLICATION]SET_INBOX_LIST_COUNT'),
    UPDATE_INBOX_STATUS_BEGIN: '[APPLICATION]UPDATE_INBOX_STATUS_BEGIN',
    UPDATE_INBOX_STATUS: asyncActionType('[APPLICATION]UPDATE_INBOX_STATUS'),

    GET_INBOX_SEARCH_FORM: asyncActionType('[APPLICATION]GET_INBOX_SEARCH_FORM'),
    GET_INBOX_SEARCH_FORM_BEGIN: '[APPLICATION]GET_INBOX_SEARCH_FORM_BEGIN',

    CHANGE_INBOX_FILTERS: '[APPLICATION]CHANGE_INBOX_FILTERS',
    APPLY_INBOX_FILTERS: '[APPLICATION]APPLY_INBOX_FILTERS',

    GET_APPOINTMENT_BY_SELECTED_DATE: asyncActionType('[APPLICATION]GET_APPOINTMENT_BY_SELECTED_DATE'),
    GET_APPOINTMENT_BY_SELECTED_DATE_BEGIN: '[APPLICATION]GET_APPOINTMENT_BY_SELECTED_DATE_BEGIN',

    SET_TIME_SHEET_SELECTED_DATE: '[APPLICATION]SET_TIME_SHEET_SELECTED_DATE',

    ADD_TIME_SHEET_COMMENT: asyncActionType('[APPLICATION]ADD_TIME_SHEET_COMMENT'),
    ADD_TIME_SHEET_COMMENT_BEGIN: '[APPLICATION]ADD_TIME_SHEET_COMMENT_BEGIN',

    GET_TIME_SHEET_COMMENT_LIST: asyncActionType('[APPLICATION]GET_TIME_SHEET_COMMENT_LIST'),
    GET_TIME_SHEET_COMMENT_LIST_BEGIN: '[APPLICATION]GET_TIME_SHEET_COMMENT_LIST_BEGIN',

    GET_TIME_SHEET_DETAILS: asyncActionType('[APPLICATION]GET_TIME_SHEET_DETAILS'),
    GET_TIME_SHEET_DETAILS_BEGIN: '[APPLICATION]GET_TIME_SHEET_DETAILS_BEGIN',

    SAVE_TIME_SHEET: asyncActionType('[APPLICATION]SAVE_TIME_SHEET'),
    SAVE_TIME_SHEET_BEGIN: '[APPLICATION]SAVE_TIME_SHEET_BEGIN',

    UPDATE_TIME_SHEET_STATUS: asyncActionType('[APPLICATION]UPDATE_TIME_SHEET_STATUS'),
    UPDATE_TIME_SHEET_STATUS_BEGIN: '[APPLICATION]UPDATE_TIME_SHEET_STATUS_BEGIN',

    PRINT_DOCUMENTS_HISTORY_LIST: asyncActionType('[APPLICATION]PRINT_DOCUMENTS_HISTORY_LIST'),
    PRINT_DOCUMENTS_HISTORY_LIST_BEGIN: '[APPLICATION]PRINT_DOCUMENTS_HISTORY_LIST_BEGIN',

    SET_PRINT_DOCUMENT_COUNT: asyncActionType('[APPLICATION]SET_PRINT_DOCUMENT_COUNT'),

    DOWNLOAD_INSPECTOR_PACKET: asyncActionType('[APPLICATION]DOWNLOAD_INSPECTOR_PACKET'),
    DOWNLOAD_INSPECTOR_PACKET_BEGIN: '[APPLICATION]DOWNLOAD_INSPECTOR_PACKET_BEGIN',

    GET_PERSON_FILE_LIST: asyncActionType('[APPLICATION]GET_PERSON_FILE_LIST'),
    GET_PERSON_FILE_LIST_BEGIN: '[APPLICATION]GET_PERSON_FILE_LIST_BEGIN',

    DELETE_PERSON_FILE_DOCUMENT: asyncActionType('[APPLICATION]DELETE_PERSON_FILE_DOCUMENT'),
    DELETE_PERSON_FILE_DOCUMENT_BEGIN: '[APPLICATION]DELETE_PERSON_FILE_DOCUMENT_BEGIN',

    DOWNLOAD_PERSON_FILE_DOCUMENT: asyncActionType('[APPLICATION]DOWNLOAD_PERSON_FILE_DOCUMENT'),
    DOWNLOAD_PERSON_FILE_DOCUMENT_BEGIN: '[APPLICATION]DOWNLOAD_PERSON_FILE_DOCUMENT_BEGIN',

    DOWNLOAD_TIMESHEET_PACKET: asyncActionType('[APPLICATION]DOWNLOAD_TIMESHEET_PACKET'),
    DOWNLOAD_TIMESHEET_PACKET_BEGIN: '[APPLICATION]DOWNLOAD_TIMESHEET_PACKET_BEGIN',

    GET_ADD_INSPECTION_FORM_BY_ID: asyncActionType('[APPLICATION]GET_ADD_INSPECTION_FORM_BY_ID'),
    GET_ADD_INSPECTION_FORM_BY_ID_BEGIN: '[APPLICATION]GET_ADD_INSPECTION_FORM_BY_ID_BEGIN',

    GET_ADD_CONTACT_FORM: asyncActionType('[APPLICATION]GET_ADD_CONTACT_FORM'),
    GET_ADD_CONTACT_FORM_BEGIN: '[APPLICATION]GET_ADD_CONTACT_FORM_BEGIN',

    GET_LINKED_LICENSES_FOR_APPOINTMENT: asyncActionType('[APPLICATION]GET_LINKED_LICENSES_FOR_APPOINTMENT'),
    GET_LINKED_LICENSES_FOR_APPOINTMENT_BEGIN: '[APPLICATION]GET_LINKED_LICENSES_FOR_APPOINTMENT_BEGIN',

    ADD_LICENSES_FOR_APPOINTMENT: asyncActionType('[APPLICATION]ADD_LICENSES_FOR_APPOINTMENT'),
    ADD_LICENSES_FOR_APPOINTMENT_BEGIN: '[APPLICATION]ADD_LICENSES_FOR_APPOINTMENT_BEGIN',

    GET_FILTERED_LICENSES_FOR_APPOINTMENT: asyncActionType('[APPLICATION]GET_FILTERED_LICENSES_FOR_APPOINTMENT'),
    GET_FILTERED_LICENSES_FOR_APPOINTMENT_BEGIN: '[APPLICATION]GET_FILTERED_LICENSES_FOR_APPOINTMENT_BEGIN',

    SET_APPOINTMENT_PERSONS: '[APPLICATION]SET_APPOINTMENT_PERSONS_SUCCESS',
    REMOVE_LICENSE_FROM_APPOINTMENT: asyncActionType('[APPLICATION]REMOVE_LICENSE_FROM_APPOINTMENT'),
    REMOVE_LICENSE_FROM_APPOINTMENT_BEGIN: '[APPLICATION]REMOVE_LICENSE_FROM_APPOINTMENT_BEGIN',

    GET_CALENDAR_SEARCH_FORM: asyncActionType('[APPLICATION]GET_CALENDAR_SEARCH_FORM'),
    GET_CALENDAR_SEARCH_FORM_BEGIN: '[APPLICATION]GET_CALENDAR_SEARCH_FORM_BEGIN',

    GET_TIMESHEET_SEARCH_FORM: asyncActionType('[APPLICATION]GET_TIMESHEET_SEARCH_FORM_BEGIN'),
    GET_TIMESHEET_SEARCH_FORM_BEGIN: '[APPLICATION]GET_TIMESHEET_SEARCH_FORM_BEGIN',

    APPLY_TIMESHEET_FILTERS: '[APPLICATION]APPLY_TIMESHEET_FILTERS',
    SET_TIMESHEET_FILTERS_SELECTION: '[APPLICATION]SET_TIMESHEET_FILTERS_SELECTION',

    GET_CITATION_SEARCH_FORM: asyncActionType('[APPLICATION]GET_CITATION_SEARCH_FORM'),
    GET_CITATION_SEARCH_FORM_BEGIN: '[APPLICATION]GET_CITATION_SEARCH_FORM_BEGIN',

    ADD_BULK_APPOINTMENT: asyncActionType('[APPLICATION]ADD_BULK_APPOINTMENT'),
    ADD_BULK_APPOINTMENT_BEGIN: '[APPLICATION]ADD_BULK_APPOINTMENT_BEGIN',

    GET_OPENED_VIOLATIONS: asyncActionType('[APPLICATION]GET_OPENED_VIOLATIONS'),
    GET_OPENED_VIOLATIONS_BEGIN: '[APPLICATION]GET_OPENED_VIOLATIONS_BEGIN',

    CLOSE_BULK_VIOLATIONS: asyncActionType('[APPLICATION]CLOSE_BULK_VIOLATIONS'),
    CLOSE_BULK_VIOLATIONS_BEGIN: '[APPLICATION]CLOSE_BULK_VIOLATIONS_BEGIN',

    DOWNLOAD_INVOICE: asyncActionType('[MUNICIPALITY]DOWNLOAD_INVOICE'),
    DOWNLOAD_INVOICE_BEGIN: '[MUNICIPALITY]DOWNLOAD_INVOICE_BEGIN',

    SET_LICENSE_COLUMN_SORT: '[APPLICATION]SET_LICENSE_COLUMN_SORT',
};

// Status types
export const FETCH_STATUS = {
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};

export default {
    ...FILTER_ACTIONS,
};

export const MESSAGES = {
    NO_AUDIT_HISTORY: 'No Audit History data',
    FILE_UPLOAD_SUCCESS: 'success',
    FILE_UPLOAD_FAIL: 'fail',
};
export const APPLICATION_TYPES = {
    APPLICATION: 'Application',
    LICENSE: 'License',
    TRANSCRIPT: 'Transcript',
    PICTURE: 'Picture',
    CORRESPONDENCE: 'Correspondence',
    SVD: 'SVD',
    SAVE: 'SAVE',
    PANDZ: 'P & Z',
};

export const LICENSE_STATUS = ['Active', 'Pending', 'Inactive', 'Denied'];

export const CITATION_STATUS = ['Pending', 'In Review', 'Processed'];

export const NOTIFICATION_TYPE = { error: 'error', success: 'success', info: 'info', warning: 'warning' };

export const LICENSE_ORDER_BY_COL = {
    id: 'id',
    licenseNumber: 'licenseNumber',
    type: 'type',
    receivedDate: 'receivedDate',
    name: 'name',
    status: 'status',
};
export const LICENSE_ORDER_BY_BACKEND: any = {
    licenseNumber: 'licenseNumber',
    'type.name': 'type.name',
    receivedDate: 'applications.receivedDate',
    name: 'person.name',
    status: 'status',
    expirationDate: 'expirationDate',
    issueDate: 'issueDate',
};

export const DETAILS_TAB_LIST = [
    { id: 'licenseData', name: 'License Data' },
    { id: 'inspections', name: 'Inspections' },
    { id: 'violations', name: 'Violations' },
    { id: 'files', name: 'Files' },
    { id: 'accounting', name: 'Accounting' },
    { id: 'comments', name: 'Comments' },
    { id: 'history', name: 'History' },
];

export const CITATION_DETAILS_TAB_LIST = [
    { id: 0, name: 'Citation Data' },
    { id: 1, name: 'Licenses' },
    { id: 2, name: 'Fees' },
    { id: 3, name: 'Files' },
    { id: 4, name: 'Comments' },
];

export const INSPECTION_DETAIL_TAB_LIST = [
    { id: 0, name: 'Inspection Data' },
    { id: 1, name: 'Violations' },
    { id: 2, name: 'Comments' },
];

export const VIOLATION_DETAIL_TAB_LIST = [
    { id: 0, name: 'Violation Data' },
    { id: 1, name: 'Comments' },
];
export const PERSON_TAB_LIST = [
    { id: 'personData', name: 'Details' },
    { id: 'contacts', name: 'Contacts' },
    { id: 'licenses', name: 'Licenses' },
    { id: 'files', name: 'Files' },
    { id: 'accounting', name: 'Accounting' },
    { id: 'events', name: 'Appointments' },
    { id: 'comments', name: 'Comments' },
    { id: 'history', name: 'History' },
];
export const APPOINTMENT_DETAIL_TAB_LIST = [
    { id: 0, name: 'Appointment Data' },
    { id: 1, name: 'License Owners' },
    { id: 2, name: 'Licenses' },
    { id: 4, name: 'Comments' },
];

export const APPOINTMENT_INSPECTION_DETAIL_TAB_LIST = [
    { id: 0, name: 'Appointment Data' },
    { id: 1, name: 'License Owners' },
    { id: 2, name: 'Licenses' },
    { id: 3, name: 'Inspections' },
    { id: 4, name: 'Comments' },
];

export const LICENSE_HISTORY_CATEGORY_LIST = [
    { id: 0, name: 'All', value: 'All' },
    { id: 1, name: 'License Data', value: 'License' },
    { id: 2, name: 'Inspections', value: 'Inspection' },
    { id: 3, name: 'Violations', value: 'Violation' },
    { id: 4, name: 'Citations', value: 'Citation' },
    { id: 5, name: 'Accounting', value: 'JournalEntry' },
    { id: 6, name: 'Files', value: 'Files' },
    { id: 7, name: 'Print Documents', value: 'MergeQueueItem' },
];

export const PERSON_HISTORY_CATEGORY_LIST = [
    { id: 0, name: 'All', value: 'All' },
    { id: 1, name: 'Details', value: 'Details' },
    { id: 2, name: 'Contacts', value: 'Contacts' },
    { id: 3, name: 'Licenses', value: 'License' },
    { id: 4, name: 'Accounting', value: 'JournalEntry' },
    { id: 5, name: 'Files', value: 'Files' },
    { id: 6, name: 'Appointments', value: 'Event' },
    { id: 7, name: 'Comments', value: 'Comment' },
];

export const OPERATOR_MAP: Record<string, string> = {
    like: 'like',
    in: 'inq',
    greaterThan: 'gt',
    greaterThanEqual: 'gte',
    lessThan: 'lt',
    lessThanEqual: 'lte',
};

export const inspectionStatus = {
    Found: {
        label: 'Completed - Pass',
        value: 'Completed - Pass',
    },
    Corrected: {
        label: 'Completed - Fail',
        value: 'Completed - Fail',
    },
};

// This item contains the ids of all the tabs that needs to be shown/hidden dynamically
export const CUSTOM_TAB_IDS = ['inspections', 'violations'];

// This item contains the ids of all the tabs that needs to be shown/hidden dynamically in person details
export const CUSTOM_TAB_IDS_PERSON_DETAILS = ['appointments'];

export const INSPECTIONS = 'Inspections';
export const VIOLATIONS = 'Violations';
export const COMMENTS = 'Comments';
export const APP_STATUS_PENDING = 'Pending';
export const APP_STATUS_ACTIVE = 'Active';
export const APP_STATUS_INACTIVE = 'Inactive';
export const APP_STATUS_DENIED = 'Denied';

export const ACCOUNTING_ACCOUNTS_RECEIVABLE = '000000000000000000000001';
export const ACCOUNTING_UNCATEGORIZED_REVENUE = '000000000000000000000010';
export const ACCOUNTING_GENERAL_ASSETS = '000000000000000000000030';
export const INSPECTION_EVENT_TYPE = '000000000000000000000001';

export const EXPERIMENTAL = 'Experimental';

export const EVENT_ORDER_BY_COL = {
    id: 'id',
    startDateTime: 'startDateTime',
    type: 'type',
    address: 'address',
};
export const EVENT_ORDER_BY_BACKEND: any = {
    appointmentDateTime: 'startDateTime',
    type: 'type.name',
    address: 'address.line1',
    participants: 'participants.name',
    persons: 'persons.name',
};

export const INSPECTIONS_ORDER_BY_BACKEND: any = {
    license: 'license.licenseNumber',
    'type.name': 'type.name',
    'inspector.name': 'inspector.name',
    inspectionDate: 'inspectionDate',
    status: 'status',
};

export const INBOX_ORDER_BY_BACKEND: any = {
    'context.license.licenseNumber': 'context.license.licenseNumber',
    'context.person.name': 'context.person.name',
    formName: 'formName',
    submissionDate: 'submissionDate',
    type: 'type',
    status: 'status',
};

export const CITATION_ORDER_BY_BACKEND: any = {
    citationNumber: 'citationNumber',
    type: 'type.name',
    licensee: 'person.name',
    licenseeType: 'person.type.name',
    citationDate: 'citationDate',
    status: 'status',
};

/* If a route is NOT in these 2 lists, they'll be available in every tenant
 *  by default, regardless of whether they're present in its features-array: */
export const EXPERIMENTAL_ROUTES = ['Calendar', 'Time & Expense'];
export const FEATURE_ROUTES = ['Citations', 'Inbox'];

export const FEATURE_EXTERNAL_PAYMENT = 'External Payment';

export const TIME_SHEET_ORDER_BY_COL = {
    id: 'id',
    startDate: 'startDate',
    type: 'type',
};

export const TIME_SHEET_STATUS_IN_PROGRESS = 'In Progress';
export const TIME_SHEET_STATUS_SUBMITTED = 'Submitted';
export const TIME_SHEET_STATUS_APPROVED = 'Approved';

export const MAX_TOTAL_HOURS = 15;

export const PERIODICITY = [
    { label: 'Does not repeat', value: 'Does not repeat' },
    { label: 'Daily', value: 'daily' },
    { label: 'Every weekday', value: 'weekdays' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Annually', value: 'yearly' },
];

export const PERSON_LICENSES = 'licenses';
export const PERSON_CONTACTS = 'contacts';
export const PERSON_APPOINTMENTS = 'events';
export const APPOINTMENTS_LICENSES = 'licenses';

// For a data-template string (e.g. '{field1} {field2}'), passing this regex as an argument to
// the match() method would return an array of the field-names (i.e. ['field1','field2'])
export const EXTRACT_COLUMN_FIELDS_REGEX = /[^{}]+(?=})/g;
